<template>
    <div></div>
</template>

<script>
export default {
    name: 'HomeLandingPage'
}
</script>

<style lang="scss" scoped></style>
